var slate = {};
slate.utils = {
 
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },
 
  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }
 
    return array;
  },
 
  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];
 
    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },
 
  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};
 
slate.Currency = (function() {
  var moneyFormat = '${{amount}}';
 
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
 
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');
 
      if (isNaN(number) || number == null) {
        return 0;
      }
 
      number = (number / 100.0).toFixed(precision);
 
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
 
      return dollarsAmount + centsAmount;
    }
 
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
 
    return formatString.replace(placeholderRegex, value);
  }
 
  return {
    formatMoney: formatMoney
  };
})();
 
if ($(".custom-bundle").length) {
    $(".custom-bundle").empty();
    $(".custom-bundle").html($("#form-section-template").html());
  }
  window.appikonDiscounts = null;
  const map_pricing_popup = $('#map-pricing-popup');
  var app_ProductForm = new Vue({
    el: "#app_ProductForm",
    data: {
      subtotal: 0,
      discountSubtotal: 0,
      quantity: 1,
      totalQuantity: 1,
      boxes: 1,
      coverageRooms: 1,
      showCalculator: false,
      perBundle: 1,
      unit: null,
      includeWaste: false,
      waste: 10,
      minQty: 1,
      price: null,
      discountPrice: 0,
      hasProductDiscounts: false,
      appikonDiscounts: "none",
      bunleType: "Boxes",
    },
    watch: {
      boxes: function () {
        let oldQuantity = this.quantity;
 
        let newBoxes = this.boxes;
        let oldBoxes = Math.ceil(this.quantity / this.perBundle);
        /*
        console.log(
          "old: " + oldBoxes,
          "New:" + newBoxes,
          "Qty:" + this.quantity,
          "minQty:" + this.minQty
        );
        */
        if (oldBoxes !== newBoxes) {
          this.quantity = Number(
            this.getTwoFixed(String(this.boxes * this.perBundle))
          );
        }
      },
      quantity: function () {
        if(this.quantity < this.minQty){
          //this.quantity = this.minQty
          //return null;
        }
        let includeWasteSelected = this.includeWaste;
        if (includeWasteSelected) {
          this.includeWaste = false;
        }
 
        if(this.quantity>1000){
          map_pricing_popup.removeClass('hidden')
        }else{
          map_pricing_popup.addClass('hidden')
        }
 
        let oldBoxes = this.boxes;
        let newBoxes = Math.ceil(Math.floor(this.quantity) / this.perBundle);
 
        if (oldBoxes !== newBoxes) {
          this.boxes = Math.ceil(Math.floor(this.quantity) / this.perBundle);
        }
 
        let totalQuantity = Number(Math.ceil(this.perBundle * this.boxes));
 
 
        this.totalQuantity = this.includeWaste
          ? Number((this.quantity * 1.1).toFixed(2))
          : totalQuantity;
 
        var subtotalValue = Number(
          (this.price * Math.ceil(totalQuantity)).toFixed(2).replace(".", "")
        );
        this.subtotal = slate.Currency.formatMoney(
          subtotalValue,
          theme.moneyFormat
        );
 
        this.getDiscuntedValue();
 
        if (this.quantity < this.minQty) {
          $(".product-form__buttons button").prop("disabled", true);
        } else {
          $(".product-form__buttons button").prop("disabled", false);
        }
        if (includeWasteSelected) {
          setTimeout(function () {
            app_ProductForm.includeWaste = true;
          }, 100);
        }
      },
      includeWaste: function () {
        let totalQuantity = Number(Math.ceil(this.perBundle * this.boxes));
        this.totalQuantity = this.includeWaste
          ? Number((this.quantity * 1.1).toFixed(2))
          : totalQuantity;
      },
    },
    methods: {
      getDiscuntedValue: function (subtotalValue) {
        if (this.appikonDiscounts != "none") {
          let totalQuantity = Number(Math.ceil(this.perBundle * this.boxes));
          var subtotalValue = Number(
            (this.price * Math.ceil(totalQuantity)).toFixed(2).replace(".", "")
          );
 
          //console.log(window.appikonDiscounts);
          var value = Math.ceil(this.quantity);
          var discounts = this.appikonDiscounts.vol_rows;
          if (discounts && value) {
            var ammount = 0;
            for (i = 0; i < discounts.length; i++) {
              var discount = discounts[i];
              if (discount.quantity > value) {
                if (discount.price.discount_type == "dollar_off_each") {
                  var appendZero = "";
                  if (String(discount.price.amount).split(".").length > 1) {
                    if (String(discount.price.amount).split(".")[1].length > 1) {
                      var appendZero = "";
                    } else {
                      var appendZero = "0";
                    }
                  }
 
                  var string = `Add ${
                    discount.quantity - value
                  } SqFt More To Unlock Volume Pricing - Save  $${
                    String(discount.price.amount) + appendZero
                  } / SqFt.`;
                  if (i != 0) {
                    ammount = discounts[i - 1].price.amount;
                    discountPopupMsg =
                      "Congratulations, You Qualify For Volume Pricing";
                  } else {
                    discountPopupMsg = "";
                  }
                  $(".product-discount-info")
                    .html(string)
                    .removeClass("done")
                    .attr("data-message", discountPopupMsg);
                }
                break;
              } else {
                if (discounts.length - 1 == i) {
                  var string = "Congratulations, You Qualify For Volume Pricing";
                  discountPopupMsg =
                    "Congratulations, You Qualify For Volume Pricing";
                  $(".product-discount-info")
                    .html(string)
                    .addClass("text-accent")
                    .data("message", discountPopupMsg);
                  ammount = discount.price.amount;
                } else {
                  continue;
                }
              }
            }
 
            var original = this.price;
            var originalPrice = original; //( original / 100 );
            var newPrice = originalPrice - ammount;
 
            if (ammount) {
              let curr =  $(".product__info-container .price__container .price").data('currency');
              $(".product__info-container .price__container .price").html(
                `<span class="line-through italic small price-item discount mr-2">$${this.price} ${curr}</span><span class="discount price-item text-accent">$${newPrice} ${curr}</span>`
              );
 
              var totalPrice = subtotalValue; //Number( $('.estimated-cost').attr('data-total') );//$('.estimated-cost').data('total');
              var totalQty = Math.ceil(this.totalQuantity);
              var totalDiscount = totalQty * ammount * 100;
              var totalNewPrice = totalPrice - totalDiscount;
 
              //console.log(totalPrice,totalQty,totalDiscount,totalNewPrice)
 
              $(".product-discount-info").attr(
                "data-saved",
                `You saved : ${slate.Currency.formatMoney(
                  totalDiscount,
                  theme.moneyFormat
                )}`
              );
 
              //console.log(totalPrice ,'-', totalDiscount,'=',totalNewPrice, slate.Currency.formatMoney(totalNewPrice, theme.moneyFormat));
              //$('.estimated-cost').html(slate.Currency.formatMoney(totalNewPrice, theme.moneyFormat) + '<strike>'+slate.Currency.formatMoney(totalPrice, theme.moneyFormat)+'</strike>');
              this.discountSubtotal = slate.Currency.formatMoney(
                totalNewPrice,
                theme.moneyFormat
              );
            } else {
              this.discountSubtotal = 0;
              let curr =  $(".product__info-container .price__container .price").data('currency');
              $(".product__info-container .price__container .price").html(
                `<span class="price-item">$${this.price} ${curr}</span>`
              );
              $(".product-discount-info").attr("data-saved", "");
            }
          }
        }
      },
      toggleCalculator: function () {
        this.showCalculator = !this.showCalculator;
      },
      addCoverageRoom: function () {
        this.coverageRooms = this.coverageRooms + 1;
      },
      calculateCoverage: function () {
        var totalArea = 0;
        $(".coverage-area-wrap .coverage-area-group").each(function () {
          var length = $(this).find(".coverage-length-input").val();
          var width = $(this).find(".coverage-width-input").val();
          if (length && width) {
            var area = (length * width).toFixed(2);
            $(this).find(".coverage-area-output").val(area);
            totalArea += Number(area);
          }
        });
        if (totalArea) {
          $(".coverage-area-final").val(totalArea);
        }
      },
      useCoverage: function () {
        var final = $(".coverage-area-final").val();
        if (final) {
          this.quantity = final;
          this.showCalculator = false;
        }
      },
      changeBoxes: function (change) {
        if (change == "minus") {
          if (this.boxes <= 1) {
            this.boxes = 1;
          } else {
            let newBoxCount = Number(this.boxes) - 1;
            //console.log(newBoxCount , this.perBundle , this.minQty)
            if( newBoxCount * this.perBundle >= this.minQty){
              this.boxes = newBoxCount;
            }
          }
        } else {
          this.boxes = Number(this.boxes) + 1;
        }
      },
      getTwoFixed: function (string) {
        var splitVal = string.split(".");
        var val = splitVal[0];
        if (splitVal[1]) {
          val += "." + splitVal[1].slice(0, 2);
        }
        return val;
      },
    },
    beforeMount() {
      var appikonCheck = setInterval(function () {
        if (window.appikon && window.appikonDiscount.settings.app_root_url) {
          clearInterval(appikonCheck);
 
          $.ajax({
            cache: !1,
            type: "POST",
            url: window.appikonDiscount.settings.app_root_url,
            data: JSON.stringify(window.appikon),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            success: function (data) {
              if (data.vol_rows.length) {
                app_ProductForm.hasProductDiscounts = true;
                app_ProductForm.appikonDiscounts = data;
                app_ProductForm.getDiscuntedValue();
              } else {
                app_ProductForm.hasProductDiscounts = false;
                app_ProductForm.appikonDiscounts = "none";
              }
            },
          });
        }
      }, 100);
    },
    mounted() {
      //console.log("mounted");
 
      this.perBundle = Number($("#app_perBundle").attr("data-value"));
      this.minQty = Number($("#app_minQty").attr("data-value"));
      this.price = Number($("#app_price").attr("data-value"));
      this.unit = $("#app_unit").attr("data-value");
      if ($("#app_bundle_type").attr("data-value")) {
        this.bunleType = $("#app_bundle_type").attr("data-value");
      }
 
      this.quantity = this.minQty ? this.minQty : this.perBundle;
      this.totalQuantity = this.includeWaste
        ? (this.quantity * 1.1).toFixed(2)
        : this.quantity;
      // this.subtotal = Math.ceil( this.quantity ) * this.price ;
      this.subtotal = slate.Currency.formatMoney(
        Number(
          (this.price * Math.ceil(this.quantity)).toFixed(2).replace(".", "")
        ),
        theme.moneyFormat
      );
    },
  });
 
  // ─────────────────────────────────────────────────────────────────────
  // Area snap-to-coverage on blur
  // ─────────────────────────────────────────────────────────────────────
  // When the user types into the SqFt (Area) input and then tabs out
  // or clicks away, snap the displayed Area to the actual coverage
  // (boxes × perBundle). This keeps the Area field consistent with
  // what's going into the cart, matching the Subtotal logic that
  // already snaps automatically. Runs on blur (not on every keystroke)
  // so it doesn't disrupt the user mid-typing.
  //
  // Selector covers both V5 section (#Quantity-product, .womf-calc-field__input)
  // and any legacy sections that still use .product-requirement.
  $(document).on("blur", "#Quantity-product, .product-requirement", function () {
    if (typeof app_ProductForm === "undefined") return;
    var boxes = Number(app_ProductForm.boxes);
    var perBundle = Number(app_ProductForm.perBundle);
    if (boxes > 0 && perBundle > 0) {
      var snapped = Number((boxes * perBundle).toFixed(2));
      if (snapped !== Number(app_ProductForm.quantity)) {
        app_ProductForm.quantity = snapped;
      }
    }
  });
 
  // Pressing Enter inside the SqFt input also triggers the snap
  // (blurs the input, which fires the handler above).
  $(document).on("keydown", "#Quantity-product, .product-requirement", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      $(this).blur();
    }
  });
 